import type { UseEnterpriseMyPageHeaderResult as MyEnterprisePageHeader } from 'bundles/composable-page-header-enterprise/contexts/EnterpriseMyPageHeaderContext';
import type {
  EnterpriseProgramFromSlugFragment,
  NaptimeThirdPartyOrganizationFromSlugFragment,
} from 'bundles/enterprise-legacy-learner-home/queries/__generated__/EnterpriseProgramBySlugQuery';

export const mergeEnterpriseDataWithBackup = (
  bffData?: MyEnterprisePageHeader,
  backupProgram?: EnterpriseProgramFromSlugFragment,
  backupThirdParty?: NaptimeThirdPartyOrganizationFromSlugFragment
): MyEnterprisePageHeader => {
  /**
   * Interpolating bffData first with a backup or blank entry just in case
   * Always prefer existing BFF data if it's present!
   */
  return {
    currentPageProgram: bffData?.currentPageProgram ?? backupProgram,
    chosenEnterpriseProgram: bffData?.chosenEnterpriseProgram ?? backupProgram,
    chosenDegree: bffData?.chosenDegree ?? undefined,
    enrolledDegreePrograms: bffData?.enrolledDegreePrograms ?? undefined,
    enrolledEnterprisePrograms: bffData?.enrolledEnterprisePrograms ?? (backupProgram ? [backupProgram] : undefined),
    naptimeManagedThirdPartyOrganizations: bffData?.naptimeManagedThirdPartyOrganizations ?? undefined,
    hasCheatingIncidents: bffData?.hasCheatingIncidents ?? undefined,
    canViewEducatorAdminLink: bffData?.canViewEducatorAdminLink ?? undefined,
    isCourseraPlusLearner: bffData?.isCourseraPlusLearner ?? undefined,
    courseraPlusSubscriptionCycle: bffData?.courseraPlusSubscriptionCycle ?? undefined,
    hasEnrolledPrograms: bffData?.hasEnrolledPrograms ?? undefined,
  };
};
